"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_DISABLED = exports.DATA_HAS_ERROR = exports.DATA_CHECK_TYPE = exports.CHECK_TYPES = void 0;
var CHECK_TYPES = {
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
  INDETERMINATE: 'indeterminate'
};
exports.CHECK_TYPES = CHECK_TYPES;
var DATA_CHECK_TYPE = 'data-check-type';
exports.DATA_CHECK_TYPE = DATA_CHECK_TYPE;
var DATA_HAS_ERROR = 'data-has-error';
exports.DATA_HAS_ERROR = DATA_HAS_ERROR;
var DATA_DISABLED = 'data-disabled';
exports.DATA_DISABLED = DATA_DISABLED;